import ProsemirrorEditor from 'hubspot-prosemirror/prosemirror/ProsemirrorEditorWithoutDnd';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function ProsemirrorRichTextEditor({
  editorState,
  setEditorState,
  rteConfig,
  prosemirrorTrackerProperties
}) {
  const editorConfig = useMemo(() => rteConfig.baseConfig, [rteConfig.baseConfig]);
  const customPlugins = useMemo(() => rteConfig.customPlugins, [rteConfig.customPlugins]);
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "rich-text-editor",
    children: /*#__PURE__*/_jsx(ProsemirrorEditor, {
      editorState: editorState,
      setEditorState: setEditorState,
      editorConfig: editorConfig,
      customPlugins: customPlugins,
      inputClassName: "rich-text-editor-input rte-border",
      autoFocus: false,
      usageTrackerProperties: prosemirrorTrackerProperties
    })
  });
}
export default ProsemirrorRichTextEditor;